export const weekTwo = [
  {
    "name": "Kenney Thomas",
    "secSunday": "A - PDO",
    "secMonday": "A - PDO",
    "secTuesday": "09:00 - 17:00 7.4hbtr2 LDDISP",
    "secWednesday": "09:00 - 17:00 7.4hbtr2 LDDISP",
    "secThursday": "09:00 - 17:00 7.4hbtr2 LDDISP",
    "secFriday": "08:00 - 16:00 7.4hbtr2 LDDISP",
    "secSaturday": "08:00 - 16:00 7.4hbtr2 LDDISP",
    "type": "leadFOH"
  },
  {
    "name": "Erika Garcia",
    "secSunday": "11:30 - 19:30 7.4hisla BARTD",
    "secMonday": "13:00 - 20:00 6.4hisla BARTD",
    "secTuesday": "A",
    "secWednesday": "A",
    "secThursday": "13:00 - 20:00 6.4hisla BARTD",
    "secFriday": "13:00 - 20:00 6.4hisla BARTD",
    "secSaturday": "13:00 - 21:00 7.4hisla BARTD",
    "type": "bartender"
  },
  {
    "name": "Silvia V Lopez",
    "secSunday": "08:00 - 16:00 7.4h3brm STAATT",
    "secMonday": "09:30 - 17:30 7.4h3brm STAATT",
    "secTuesday": "09:30 - 17:30 7.4h3brm STAATT",
    "secWednesday": "09:30 - 17:30 7.4h3brm STAATT",
    "secThursday": "09:30 - 17:30 7.4h3brm STAATT",
    "secFriday": "N",
    "secSaturday": "N",
    "type": "standAtt"
  },
  {
    "name": "Jeanne M Quirus",
    "secSunday": "N",
    "secMonday": "N",
    "secTuesday": "09:00 - 17:00 7.4hhogs BARTD",
    "secWednesday": "09:00 - 17:00 7.4hhogs BARTD",
    "secThursday": "09:00 - 17:00 7.4hhogs BARTD",
    "secFriday": "08:00 - 16:00 7.4hhogs BARTD",
    "secSaturday": "08:00 - 16:00 7.4hhogs BARTD",
    "type": "bartender"
  },
  {
    "name": "Nicholas F Lozano",
    "secSunday": "10:00 - 18:00 7.4hduff LDBRTN",
    "secMonday": "10:00 - 18:00 7.4hmoes LDBRTN",
    "secTuesday": "12:00 - 20:00 7.4hhogs LDBRTN",
    "secWednesday": "12:00 - 20:00 7.4hhogs LDBRTN",
    "secThursday": "A",
    "secFriday": "A",
    "secSaturday": "14:00 - 22:00 7.4hduff LDBRTN",
    "type": "bartender"
  },
  {
    "name": "Delone D Reynolds",
    "secSunday": "A - PDO",
    "secMonday": "A - PDO",
    "secTuesday": "06:30 - 14:30 7.4h3brm LDBOH",
    "secWednesday": "07:00 - 15:00 7.4h3brm LDBOH",
    "secThursday": "06:30 - 14:30 7.4h3brm LDBOH",
    "secFriday": "06:30 - 14:30 7.4h3brm LDBOH",
    "secSaturday": "07:00 - 15:00 7.4h3brm LDBOH",
    "type": "leadBOH"
  },
  {
    "name": "Dayra M Gonzalez",
    "secSunday": "N",
    "secMonday": "N",
    "secTuesday": "09:00 - 17:00 7.4h3brm STAATT",
    "secWednesday": "N",
    "secThursday": "17:30 - 23:30 6hhpfd STAATT  FDWN",
    "secFriday": "17:30 - 23:30 6hhpfd STAATT  FDWN",
    "secSaturday": "P: 04:00-16:00VAC",
    "type": "standAtt"
  },
  {
    "name": "Katoncia L Holder",
    "secSunday": "13:00 - 20:00 6.4hhogs BARTD",
    "secMonday": "13:00 - 20:00 6.4hmoes BARTD",
    "secTuesday": "13:00 - 20:00 6.4hduff BARTD",
    "secWednesday": "13:00 - 20:00 6.4hduff BARTD",
    "secThursday": "N",
    "secFriday": "12:00 - 19:00 6.4hduff BARTD",
    "secSaturday": "N",
    "type": "bartender"
  },
  {
    "name": "Neeranut Iamnoi",
    "secSunday": "10:30 - 18:30 7.4hhogs LDBRTN",
    "secMonday": "12:00 - 20:00 7.4hhogs LDBRTN",
    "secTuesday": "N - PDO",
    "secWednesday": "N - PDO",
    "secThursday": "12:00 - 20:00 7.4hhogs LDBRTN",
    "secFriday": "12:00 - 20:00 7.4hhogs LDBRTN",
    "secSaturday": "10:30 - 18:30 7.4hhogs LDBRTN",
    "type": "bartender"
  },
  {
    "name": "Rachel M Podber",
    "secSunday": "13:00 - 21:00 7.4hduff LDBRTN",
    "secMonday": "10:00 - 18:00 7.4hduff LDBRTN",
    "secTuesday": "10:00 - 18:00 7.4hduff LDBRTN",
    "secWednesday": "10:00 - 18:00 7.4hduff LDBRTN",
    "secThursday": "A",
    "secFriday": "P: 12:30-23:00",
    "secSaturday": "10:00 - 18:00 7.4hduff LDBRTN",
    "type": "bartender"
  },
  {
    "name": "Berta E Kodner",
    "secSunday": "08:30 - 16:30 7.4h3brm STAATT",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "09:30 - 17:30 7.4h3brm STAATT",
    "secThursday": "17:30 - 23:30 6hhpfd STAATT  FDWN",
    "secFriday": "17:30 - 23:30 6hhpfd STAATT  FDWN",
    "secSaturday": "08:30 - 16:30 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Rachel M Ruiz",
    "secSunday": "10:30 - 18:30 7.4hmoes LDBRTN",
    "secMonday": "A",
    "secTuesday": "A",
    "secWednesday": "10:00 - 18:00 7.4hmoes LDBRTN",
    "secThursday": "10:00 - 18:00 7.4hmoes LDBRTN",
    "secFriday": "09:00 - 17:00 7.4hmoes LDBRTN",
    "secSaturday": "11:00 - 19:00 7.4hmoes LDBRTN",
    "type": "bartender"
  },
  {
    "name": "Stephanie Ruiz",
    "secSunday": "10:30 - 17:30 6.4hisla BARTD",
    "secMonday": "10:30 - 16:30 6hisla BARTD",
    "secTuesday": "13:00 - 20:00 6.4hisla BARTD",
    "secWednesday": "A",
    "secThursday": "A",
    "secFriday": "11:30 - 18:30 6.4hisla BARTD",
    "secSaturday": "12:00 - 20:00 7.4hisla BARTD",
    "type": "bartender"
  },
  {
    "name": "Gorbachev Lingad",
    "secSunday": "08:00 - 16:00 7.4hbtr2 LDDISP",
    "secMonday": "09:00 - 17:00 7.4hbtr2 LDDISP",
    "secTuesday": "12:00 - 20:00 7.4hbtr2 STAATT",
    "secWednesday": "A",
    "secThursday": "A",
    "secFriday": "09:30 - 17:30 7.4h3brm STAATT",
    "secSaturday": "11:30 - 19:30 7.4hvend STAATT",
    "type": "leadFOH"
  },
  {
    "name": "Steven A Walker",
    "secSunday": "14:00 - 20:00 6hmoes BARTD",
    "secMonday": "10:00 - 16:00 6hmull BARTD",
    "secTuesday": "A",
    "secWednesday": "A",
    "secThursday": "17:30 - 23:30 6hfood BARTD  FDWN",
    "secFriday": "17:30 - 23:30 6hfood BARTD  FDWN",
    "secSaturday": "09:00 - 15:00 6hmoes BARTD",
    "type": "bartender"
  },
  {
    "name": "Danny A Cruz",
    "secSunday": "07:00 - 15:00 7.4h3brm COOKHP",
    "secMonday": "08:00 - 16:00 7.4h3brm COOKHP",
    "secTuesday": "08:00 - 16:00 7.4h3brm COOKHP",
    "secWednesday": "08:00 - 16:00 7.4h3brm COOKHP",
    "secThursday": "08:00 - 16:00 7.4h3brm COOKHP",
    "secFriday": "N",
    "secSaturday": "N",
    "type": "cook"
  },
  {
    "name": "Raven A Douglass",
    "secSunday": "13:00 - 21:00 7.4hmull LDBRTN",
    "secMonday": "A - PDO",
    "secTuesday": "A - PDO",
    "secWednesday": "11:00 - 19:00 7.4hmull LDBRTN",
    "secThursday": "10:00 - 18:00 7.4hduff LDBRTN",
    "secFriday": "10:00 - 18:00 7.4hduff LDBRTN",
    "secSaturday": "14:00 - 22:00 7.4hmull LDBRTN",
    "type": "bartender"
  },
  {
    "name": "Janee M Ervin",
    "secSunday": "14:00 - 21:00 6.4hisla BARTD",
    "secMonday": "A",
    "secTuesday": "A",
    "secWednesday": "13:00 - 20:00 6.4hisla BARTD",
    "secThursday": "17:30 - 23:30 6hfood BARTD  FDWN",
    "secFriday": "17:30 - 23:30 6hfood BARTD  FDWN",
    "secSaturday": "15:00 - 22:00 6.4hisla BARTD",
    "type": "bartender"
  },
  {
    "name": "Paige Miller",
    "secSunday": "10:00 - 18:00 7.4hmull LDBRTN",
    "secMonday": "P: 13:30-04:00",
    "secTuesday": "11:00 - 19:00 7.4hmull LDBRTN",
    "secWednesday": "P: 13:30-04:00",
    "secThursday": "11:00 - 19:00 7.4hmull LDBRTN",
    "secFriday": "11:00 - 19:00 7.4hmull LDBRTN",
    "secSaturday": "10:00 - 18:00 7.4hmull LDBRTN",
    "type": "bartender"
  },
  {
    "name": "Eric D Mulgannon",
    "secSunday": "ADNS",
    "secMonday": "ADNS",
    "secTuesday": "ADNS",
    "secWednesday": "ADNS",
    "secThursday": "ADNS",
    "secFriday": "ADNS",
    "secSaturday": "ADNS"
  },
  {
    "name": "Jennifer Calzadilla",
    "secSunday": "A",
    "secMonday": "A",
    "secTuesday": "A",
    "secWednesday": "A",
    "secThursday": "A",
    "secFriday": "A",
    "secSaturday": "A"
  },
  {
    "name": "Jose A Escobar",
    "secSunday": "A",
    "secMonday": "11:00 - 19:00 7.4hmull LDBRTN",
    "secTuesday": "10:00 - 18:00 7.4hmoes LDBRTN",
    "secWednesday": "A",
    "secThursday": "17:30 - 23:30 6hfood BARTD  FDWN",
    "secFriday": "17:30 - 23:30 6hfood BARTD  FDWN",
    "secSaturday": "14:00 - 22:00 7.4hmoes LDBRTN",
    "type": "bartender"
  },
  {
    "name": "Joseph L Velasco",
    "secSunday": "A - PDO",
    "secMonday": "A - PDO",
    "secTuesday": "12:00 - 20:00 7.4hbtr1 LDRUN",
    "secWednesday": "08:00 - 16:00 7.4hbtr1 LDRUN",
    "secThursday": "17:30 - 23:30 6hhpfd STAATT  FDWN",
    "secFriday": "17:30 - 23:30 6hhpfd STAATT  FDWN",
    "secSaturday": "14:00 - 22:00 7.4hbtr1 LDRUN",
    "type": "runner"
  },
  {
    "name": "Abby E Aaronson",
    "secSunday": "07:00 - 15:00 7.4h3brm COOKHP",
    "secMonday": "08:00 - 16:00 7.4h3brm COOKHP",
    "secTuesday": "10:00 - 18:00 7.4h3brm COOKHP",
    "secWednesday": "08:00 - 16:00 7.4h3brm COOKHP",
    "secThursday": "N",
    "secFriday": "N",
    "secSaturday": "07:00 - 15:00 7.4h3brm COOKHP",
    "type": "cook"
  },
  {
    "name": "Guillermo A Lino",
    "secSunday": "N",
    "secMonday": "N",
    "secTuesday": "10:00 - 16:00 6hmull BARTD",
    "secWednesday": "13:00 - 20:00 6.4hmoes BARTD",
    "secThursday": "13:00 - 20:00 6.4hmoes BARTD",
    "secFriday": "10:00 - 16:00 6hmull BARTD",
    "secSaturday": "11:30 - 18:30 6.4hduff BARTD",
    "type": "bartender"
  },
  {
    "name": "Julio C Aceves",
    "secSunday": "N",
    "secMonday": "N",
    "secTuesday": "08:30 - 16:30 7.4h3brm COOKHP",
    "secWednesday": "08:30 - 16:30 7.4h3brm COOKHP",
    "secThursday": "08:00 - 16:00 7.4h3brm COOKHP",
    "secFriday": "07:00 - 15:00 7.4h3brm COOKHP",
    "secSaturday": "N",
    "type": "cook"
  },
  {
    "name": "Larry Gunter",
    "secSunday": "N",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "10:00 - 16:00 6hmull BARTD",
    "secFriday": "P: 09:00-22:00",
    "secSaturday": "12:00 - 18:00 6hmoes BARTD",
    "type": "bartender"
  },
  {
    "name": "Shawna E Foster",
    "secSunday": "11:30 - 17:30 6hmoes BARTD",
    "secMonday": "13:00 - 20:00 6.4hduff BARTD",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "N",
    "secFriday": "A",
    "secSaturday": "11:00 - 17:00 6hmull BARTD",
    "type": "bartender"
  },
  {
    "name": "April A Lovins",
    "secSunday": "N",
    "secMonday": "N",
    "secTuesday": "08:30 - 16:30 7.4h3brm COOKHP",
    "secWednesday": "08:30 - 16:30 7.4h3brm COOKHP",
    "secThursday": "08:30 - 16:30 7.4h3brm COOKHP",
    "secFriday": "07:00 - 15:00 7.4h3brm COOKHP",
    "secSaturday": "07:00 - 15:00 7.4h3brm COOKHP",
    "type": "cook"
  },
  {
    "name": "Venus V Marcial",
    "secSunday": "A",
    "secMonday": "A",
    "secTuesday": "A",
    "secWednesday": "A",
    "secThursday": "A - PDO",
    "secFriday": "A - PDO",
    "secSaturday": "A"
  },
  {
    "name": "Cristian Gutierrez",
    "secSunday": "P: 06:00-20:00VAC",
    "secMonday": "P: 06:00-20:00VAC",
    "secTuesday": "P: 06:00-20:00VAC",
    "secWednesday": "N",
    "secThursday": "N",
    "secFriday": "07:00 - 15:00 7.4hbtr1 FDRUN",
    "secSaturday": "10:30 - 18:30 7.4hbtr1 FDRUN",
    "type": "runner"
  },
  {
    "name": "Giuseppe Restreppo",
    "secSunday": "N",
    "secMonday": "A",
    "secTuesday": "N",
    "secWednesday": "10:00 - 16:00 6hmull BARTD",
    "secThursday": "17:30 - 23:30 6hfood BARTD  FDWN",
    "secFriday": "17:30 - 23:30 6hfood BARTD  FDWN",
    "secSaturday": "15:00 - 21:00 6hmull BARTD",
    "type": "bartender"
  },
  {
    "name": "Isaac Garcia",
    "secSunday": "N",
    "secMonday": "N",
    "secTuesday": "09:00 - 17:00 7.4h3brm COOKHP",
    "secWednesday": "09:00 - 17:00 7.4h3brm COOKHP",
    "secThursday": "08:30 - 16:30 7.4h3brm COOKHP",
    "secFriday": "07:30 - 15:30 7.4h3brm COOKHP",
    "secSaturday": "07:00 - 15:00 7.4h3brm COOKHP",
    "type": "cook"
  },
  {
    "name": "Pernell E Sims",
    "secSunday": "N",
    "secMonday": "P: 10:00-22:00",
    "secTuesday": "P: 10:00-22:00",
    "secWednesday": "A",
    "secThursday": "P: 10:00-22:00",
    "secFriday": "P: 10:00-22:00",
    "secSaturday": "A"
  },
  {
    "name": "Briana R Amlin",
    "secSunday": "12:00 - 18:00 6hmull BARTD",
    "secMonday": "A",
    "secTuesday": "A",
    "secWednesday": "A",
    "secThursday": "17:30 - 23:30 6hfood BARTD  FDWN",
    "secFriday": "17:30 - 23:30 6hfood BARTD  FDWN",
    "secSaturday": "A",
    "type": "bartender"
  },
  {
    "name": "Jesus Cortez",
    "secSunday": "11:00 - 19:00 7.4hbtr1 FDRUN",
    "secMonday": "12:00 - 20:00 7.4hbtr1 FDRUN",
    "secTuesday": "08:00 - 16:00 7.4hbtr1 FDRUN",
    "secWednesday": "08:00 - 16:00 7.4hbtr1 FDRUN",
    "secThursday": "08:00 - 16:00 7.4hbtr1 FDRUN",
    "secFriday": "N",
    "secSaturday": "N",
    "type": "runner"
  },
  {
    "name": "Ariel Hernandez",
    "secSunday": "13:00 - 21:00 7.4hbtr1 LDRUN",
    "secMonday": "AVAC",
    "secTuesday": "N",
    "secWednesday": "AVAC",
    "secThursday": "N",
    "secFriday": "07:00 - 15:00 7.4hbtr1 LDRUN",
    "secSaturday": "07:00 - 15:00 7.4hbtr1 LDRUN",
    "type": "runner"
  },
  {
    "name": "Dominiq Montano",
    "secSunday": "N",
    "secMonday": "A",
    "secTuesday": "A",
    "secWednesday": "N",
    "secThursday": "N",
    "secFriday": "N",
    "secSaturday": "N"
  },
  {
    "name": "Carrie L Baty",
    "secSunday": "13:00 - 21:00 7.4h3brm LDFOH",
    "secMonday": "09:00 - 17:00 7.4h3brm LDFOH",
    "secTuesday": "09:00 - 17:00 7.4h3brm LDFOH",
    "secWednesday": "A - PDO",
    "secThursday": "A - PDO",
    "secFriday": "12:00 - 20:00 7.4h3brm LDFOH",
    "secSaturday": "11:00 - 19:00 7.4h3brm LDFOH",
    "type": "leadFOH"
  },
  {
    "name": "Cristian Valdivia",
    "secSunday": "P: 05:00-17:00",
    "secMonday": "08:00 - 16:00 7.4hbtr1 FDRUN",
    "secTuesday": "12:00 - 20:00 7.4hbtr1 FDRUN",
    "secWednesday": "12:00 - 20:00 7.4hbtr1 FDRUN",
    "secThursday": "10:00 - 18:00 7.4hbtr1 FDRUN",
    "secFriday": "12:00 - 20:00 7.4hbtr1 FDRUN",
    "secSaturday": "P: 05:00-20:00",
    "type": "runner"
  },
  {
    "name": "Al-Tariq N Taylor",
    "secSunday": "N",
    "secMonday": "08:30 - 16:30 7.4h3brm COOKHP",
    "secTuesday": "09:00 - 17:00 7.4h3brm COOKHP",
    "secWednesday": "N",
    "secThursday": "12:00 - 20:00 7.4hfood COOK  FDWN",
    "secFriday": "12:00 - 20:00 7.4hfood COOK  FDWN",
    "secSaturday": "07:30 - 15:30 7.4h3brm COOKHP",
    "type": "cook"
  },
  {
    "name": "Rafael Hernandez Lomeli",
    "secSunday": "N",
    "secMonday": "07:00 - 15:00 7.4h3brm PREP",
    "secTuesday": "07:00 - 15:00 7.4h3brm PREP",
    "secWednesday": "07:00 - 15:00 7.4h3brm PREP",
    "secThursday": "07:00 - 15:00 7.4h3brm PREP",
    "secFriday": "08:00 - 16:00 7.4h3brm COOKHP",
    "secSaturday": "N",
    "type": "cook"
  },
  {
    "name": "Oscar J Benitez",
    "secSunday": "07:00 - 15:00 7.4hbtr1 FDRUN",
    "secMonday": "12:00 - 20:00 7.4hbtr1 FDRUN",
    "secTuesday": "A",
    "secWednesday": "A",
    "secThursday": "12:00 - 20:00 7.4hbtr1 FDRUN",
    "secFriday": "09:00 - 17:00 7.4hbtr1 FDRUN",
    "secSaturday": "07:00 - 15:00 7.4hbtr1 FDRUN",
    "type": "runner"
  },
  {
    "name": "Esmeralda Campos",
    "secSunday": "N",
    "secMonday": "N",
    "secTuesday": "09:30 - 15:30 6h3brm STAATT",
    "secWednesday": "09:00 - 17:00 7.4h3brm STAATT",
    "secThursday": "09:00 - 17:00 7.4h3brm STAATT",
    "secFriday": "08:30 - 16:30 7.4hbtr1 STAATT",
    "secSaturday": "08:30 - 16:30 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Michael A Gonzalez",
    "secSunday": "N",
    "secMonday": "N",
    "secTuesday": "12:00 - 20:00 7.4hbtr1 STAATT",
    "secWednesday": "11:00 - 19:00 7.4hneep STAATT",
    "secThursday": "17:30 - 23:30 6hhpfd STAATT  FDWN",
    "secFriday": "17:30 - 23:30 6hhpfd STAATT  FDWN",
    "secSaturday": "10:30 - 18:30 7.4hbtr1 FDRUN",
    "type": "standAtt"
  },
  {
    "name": "Rebekah Mendoza",
    "secSunday": "06:00 - 15:00 8hpod2 LSADMN",
    "secMonday": "N",
    "secTuesday": "10:00 - 19:00 8hpod2 LSADMN",
    "secWednesday": "N",
    "secThursday": "09:30 - 18:30 8hpod2 LSADMN",
    "secFriday": "05:30 - 14:30 8hpod2 LSADMN",
    "secSaturday": "11:30 - 20:30 8hpod2 LSADMN"
  },
  {
    "name": "Jose O Pastrana Miranda",
    "secSunday": "N",
    "secMonday": "N",
    "secTuesday": "10:00 - 18:00 7.4h3brm STAATT",
    "secWednesday": "10:00 - 18:00 7.4h3brm STAATT",
    "secThursday": "10:00 - 18:00 7.4h3brm STAATT",
    "secFriday": "10:00 - 18:00 7.4h3brm STAATT",
    "secSaturday": "P: 06:00-18:00RDO",
    "type": "standAtt"
  },
  {
    "name": "John Rivera",
    "secSunday": "N",
    "secMonday": "N",
    "secTuesday": "10:00 - 18:00 7.4h3brm STAATT",
    "secWednesday": "10:00 - 18:00 7.4h3brm STAATT",
    "secThursday": "10:00 - 18:00 7.4h3brm STAATT",
    "secFriday": "10:00 - 18:00 7.4h3brm STAATT",
    "secSaturday": "08:30 - 16:30 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Carly L Alanis De La Cruz",
    "secSunday": "09:30 - 17:30 7.4h3brm STAATT",
    "secMonday": "N",
    "secTuesday": "10:00 - 18:00 7.4h3brm STAATT",
    "secWednesday": "N",
    "secThursday": "10:00 - 18:00 7.4h3brm STAATT",
    "secFriday": "10:00 - 18:00 7.4h3brm STAATT",
    "secSaturday": "08:30 - 16:30 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Julian A Manzano",
    "secSunday": "13:00 - 21:00 7.4hbtr2 LDDISP",
    "secMonday": "12:00 - 20:00 7.4hbtr2 LDDISP",
    "secTuesday": "11:30 - 19:30 7.4hbtr2 STAATT",
    "secWednesday": "A",
    "secThursday": "A - PDO",
    "secFriday": "12:00 - 20:00 7.4hbtr1 FDRUN",
    "secSaturday": "11:00 - 19:00 7.4hbtr1 FDRUN",
    "type": "leadFOH"
  },
  {
    "name": "Cecillia S Williams",
    "secSunday": "13:00 - 21:00 7.4hbtr2 STAATT",
    "secMonday": "10:30 - 18:30 7.4h3brm STAATT",
    "secTuesday": "A - PDO",
    "secWednesday": "A - PDO",
    "secThursday": "12:00 - 20:00 7.4hbtr2 LDDISP",
    "secFriday": "11:30 - 19:30 7.4h3brm STAATT",
    "secSaturday": "10:30 - 18:30 7.4hbtr2 LDDISP",
    "type": "standAtt"
  },
  {
    "name": "Jake H Evans",
    "secSunday": "10:00 - 18:00 7.4h3brm COOKHP",
    "secMonday": "10:00 - 18:00 7.4h3brm COOKHP",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "10:00 - 18:00 7.4h3brm COOKHP",
    "secFriday": "10:00 - 18:00 7.4h3brm COOKHP",
    "secSaturday": "10:30 - 18:30 7.4h3brm COOKHP",
    "type": "cook"
  },
  {
    "name": "Daphneanne Lindley",
    "secSunday": "A",
    "secMonday": "07:30 - 15:30 7.4hfood FDTRNR  JTFD",
    "secTuesday": "09:30 - 17:30 7.4hfood FDTRNR  JTFD",
    "secWednesday": "11:30 - 19:30 7.4hfood FDTRNR  JTFD",
    "secThursday": "A - PDO",
    "secFriday": "12:00 - 20:00 7.4h3brm LDBOH",
    "secSaturday": "14:00 - 22:00 7.4h3brm LDBOH",
    "type": "leadBOH"
  },
  {
    "name": "Dannell A Smith",
    "secSunday": "N",
    "secMonday": "08:30 - 16:30 7.4h3brm COOKHP",
    "secTuesday": "07:00 - 15:00 7.4h3brm PREP",
    "secWednesday": "07:00 - 15:00 7.4h3brm PREP",
    "secThursday": "07:00 - 15:00 7.4h3brm PREP",
    "secFriday": "08:00 - 16:00 7.4h3brm COOKHP",
    "secSaturday": "N",
    "type": "cook"
  },
  {
    "name": "Christopher S Heang",
    "secSunday": "N",
    "secMonday": "10:00 - 16:00 6hbtr1 STAATT",
    "secTuesday": "10:00 - 16:00 6hbtr1 STAATT",
    "secWednesday": "09:30 - 15:30 6h3brm STAATT",
    "secThursday": "10:00 - 16:00 6hbtr1 STAATT",
    "secFriday": "08:00 - 16:00 7.4h3brm STAATT",
    "secSaturday": "N",
    "type": "standAtt"
  },
  {
    "name": "Sandy M Molina Cruz",
    "secSunday": "10:30 - 18:30 7.4hbtr1 FDRUN",
    "secMonday": "09:30 - 17:30 7.4h3brm STAATT",
    "secTuesday": "10:30 - 18:30 7.4h3brm STAATT",
    "secWednesday": "11:30 - 19:30 7.4hbtr2 STAATT",
    "secThursday": "12:00 - 20:00 7.4hbtr1 FDRUN",
    "secFriday": "N",
    "secSaturday": "N",
    "type": "runner"
  },
  {
    "name": "Liliana Rosales Rodriguez",
    "secSunday": "09:30 - 17:30 7.4h3brm STAATT",
    "secMonday": "09:30 - 17:30 7.4hbtr1 STAATT",
    "secTuesday": "09:30 - 17:30 7.4hbtr1 STAATT",
    "secWednesday": "09:30 - 17:30 7.4hbtr1 STAATT",
    "secThursday": "09:30 - 17:30 7.4hbtr1 STAATT",
    "secFriday": "N",
    "secSaturday": "N",
    "type": "standAtt"
  },
  {
    "name": "Tony L Thompson Jr.",
    "secSunday": "11:00 - 19:00 7.4hneep STAATT",
    "secMonday": "10:00 - 18:00 7.4h3brm STAATT",
    "secTuesday": "10:30 - 18:30 7.4h3brm STAATT",
    "secWednesday": "N",
    "secThursday": "N",
    "secFriday": "10:00 - 18:00 7.4hbtr1 STAATT",
    "secSaturday": "11:00 - 19:00 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Cristian Villa Trinidad",
    "secSunday": "09:30 - 17:30 7.4h3brm STAATT",
    "secMonday": "N - PDO",
    "secTuesday": "09:30 - 17:30 7.4hbtr2 STAATT",
    "secWednesday": "N - PDO",
    "secThursday": "10:00 - 18:00 7.4hbtr1 STAATT",
    "secFriday": "P: 05:00-18:00VAC",
    "secSaturday": "P: 05:00-18:00VAC",
    "type": "standAtt"
  },
  {
    "name": "Marisa Avitia",
    "secSunday": "12:00 - 20:00 7.4hneep STAATT",
    "secMonday": "10:00 - 18:00 7.4h3brm STAATT",
    "secTuesday": "10:30 - 18:30 7.4h3brm STAATT",
    "secWednesday": "12:00 - 20:00 7.4hbtr2 STAATT",
    "secThursday": "09:30 - 17:30 7.4hbtr2 STAATT",
    "secFriday": "N",
    "secSaturday": "N",
    "type": "standAtt"
  },
  {
    "name": "Mary Campbell",
    "secSunday": "A - PDO",
    "secMonday": "12:00 - 20:00 7.4hbtr2 STAATT",
    "secTuesday": "10:30 - 18:30 7.4h3brm STAATT",
    "secWednesday": "10:30 - 18:30 7.4h3brm STAATT",
    "secThursday": "10:30 - 18:30 7.4h3brm STAATT",
    "secFriday": "A - PDO",
    "secSaturday": "14:00 - 22:00 7.4hbtr2 STAATT",
    "type": "standAtt"
  },
  {
    "name": "Felicia K Tomiyasu-Gravante",
    "secSunday": "N",
    "secMonday": "NVAC",
    "secTuesday": "NVAC",
    "secWednesday": "P: 05:00-17:00VAC",
    "secThursday": "06:00 - 14:30 8hprod ADMN11  LP02",
    "secFriday": "06:00 - 14:30 8hprod ADMN11  LP02",
    "secSaturday": "N"
  },
  {
    "name": "Efren Ceccaldi",
    "secSunday": "06:30 - 14:30 7.4h3brm LDBOH",
    "secMonday": "06:30 - 14:30 7.4h3brm LDBOH",
    "secTuesday": "12:00 - 20:00 7.4h3brm LDBOH",
    "secWednesday": "12:00 - 20:00 7.4h3brm LDBOH",
    "secThursday": "12:00 - 20:00 7.4h3brm LDBOH",
    "secFriday": "A",
    "secSaturday": "A",
    "type": "leadBOH"
  },
  {
    "name": "Jacqueline Cortes",
    "secSunday": "07:30 - 15:30 7.4h3brm COOKHP",
    "secMonday": "09:00 - 17:00 7.4h3brm COOKHP",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "N",
    "secFriday": "09:30 - 17:30 7.4hfood FDTRNR  JTFD",
    "secSaturday": "07:30 - 15:30 7.4h3brm COOKHP",
    "type": "cook"
  },
  {
    "name": "Dominic Aguas",
    "secSunday": "A - PDO",
    "secMonday": "A - PDO",
    "secTuesday": "12:00 - 20:00 7.4h3brm LDFOH",
    "secWednesday": "09:00 - 17:00 7.4h3brm LDFOH",
    "secThursday": "12:00 - 20:00 7.4h3brm LDFOH",
    "secFriday": "08:00 - 16:00 7.4h3brm LDFOH",
    "secSaturday": "08:00 - 16:00 7.4h3brm LDFOH",
    "type": "leadFOH"
  },
  {
    "name": "Liliana Aguilar Fuentes",
    "secSunday": "08:00 - 14:00 6h3brm STAATT",
    "secMonday": "N",
    "secTuesday": "10:00 - 16:00 6h3brm STAATT",
    "secWednesday": "N",
    "secThursday": "P: 06:00-16:00RDO",
    "secFriday": "P: 06:00-16:00RDO",
    "secSaturday": "P: 04:00-15:00RDO",
    "type": "standAtt"
  },
  {
    "name": "Keion Drummond",
    "secSunday": "11:00 - 19:00 7.4h3brm STAATT",
    "secMonday": "10:00 - 18:00 7.4h3brm STAATT",
    "secTuesday": "11:00 - 19:00 7.4h3brm STAATT",
    "secWednesday": "10:30 - 18:30 7.4h3brm STAATT",
    "secThursday": "10:30 - 18:30 7.4h3brm STAATT",
    "secFriday": "N",
    "secSaturday": "N",
    "type": "standAtt"
  },
  {
    "name": "Mark A Gutierrez",
    "secSunday": "P: 07:30-20:00",
    "secMonday": "P: 07:30-20:00VAC",
    "secTuesday": "AVAC",
    "secWednesday": "AVAC",
    "secThursday": "NVAC",
    "secFriday": "NVAC",
    "secSaturday": "P: 07:00-20:00"
  },
  {
    "name": "Marco A Lopez Jr.",
    "secSunday": "P: 09:00-22:00RDO",
    "secMonday": "10:30 - 18:30 7.4h3brm STAATT",
    "secTuesday": "11:30 - 19:30 7.4h3brm STAATT",
    "secWednesday": "10:30 - 18:30 7.4h3brm STAATT",
    "secThursday": "10:30 - 18:30 7.4h3brm STAATT",
    "secFriday": "N",
    "secSaturday": "N",
    "type": "standAtt"
  },
  {
    "name": "Haisy Gomez",
    "secSunday": "09:30 - 17:30 7.4h3brm STAATT",
    "secMonday": "10:30 - 16:30 6h3brm STAATT",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "11:00 - 19:00 7.4hneep STAATT",
    "secFriday": "11:30 - 19:30 7.4h3brm STAATT",
    "secSaturday": "P: 05:00-19:00VAC",
    "type": "standAtt"
  },
  {
    "name": "Rachid F Frihi",
    "secSunday": "07:00 - 15:00 7.4hbtr1 LDRUN",
    "secMonday": "08:00 - 16:00 7.4hbtr1 LDRUN",
    "secTuesday": "08:00 - 16:00 7.4hbtr1 LDRUN",
    "secWednesday": "12:00 - 20:00 7.4hbtr1 LDRUN",
    "secThursday": "08:00 - 16:00 7.4hbtr1 LDRUN",
    "secFriday": "N",
    "secSaturday": "N",
    "type": "runner"
  },
  {
    "name": "Abrahan Luna",
    "secSunday": "13:00 - 21:00 7.4hbtr1 FDRUN",
    "secMonday": "10:30 - 18:30 7.4h3brm STAATT",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "11:00 - 19:00 7.4h3brm STAATT",
    "secFriday": "11:30 - 19:30 7.4h3brm STAATT",
    "secSaturday": "14:00 - 22:00 7.4hbtr1 FDRUN",
    "type": "runner"
  },
  {
    "name": "Arlene Manilla",
    "secSunday": "09:30 - 17:30 7.4h3brm STAATT",
    "secMonday": "09:30 - 17:30 7.4hbtr2 STAATT",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "09:30 - 17:30 7.4hneep STAATT",
    "secFriday": "08:30 - 16:30 7.4hbtr2 STAATT",
    "secSaturday": "P: 07:00-18:00RDO",
    "type": "standAtt"
  },
  {
    "name": "David E Lobo",
    "secSunday": "A - PDO",
    "secMonday": "12:00 - 20:00 7.4h3brm LDBOH",
    "secTuesday": "11:30 - 19:30 7.4h3brm COOKHP",
    "secWednesday": "04:00 - 12:00 7.4h3brm LDBOH",
    "secThursday": "A",
    "secFriday": "07:00 - 15:00 7.4h3brm LDPREP",
    "secSaturday": "AVAC",
    "type": "leadBOH"
  },
  {
    "name": "David Mendoza",
    "secSunday": "07:30 - 15:30 7.4h3brm COOKHP",
    "secMonday": "09:00 - 17:00 7.4h3brm COOKHP",
    "secTuesday": "10:00 - 18:00 7.4h3brm COOKHP",
    "secWednesday": "N",
    "secThursday": "N",
    "secFriday": "N",
    "secSaturday": "07:30 - 15:30 7.4h3brm COOKHP",
    "type": "cook"
  },
  {
    "name": "Robint R Rodriguez",
    "secSunday": "07:30 - 15:30 7.4h3brm COOKHP",
    "secMonday": "07:00 - 15:00 7.4h3brm PREP",
    "secTuesday": "P: 06:00-16:00",
    "secWednesday": "N",
    "secThursday": "09:00 - 17:00 7.4h3brm COOKHP",
    "secFriday": "09:00 - 17:00 7.4h3brm COOKHP",
    "secSaturday": "08:00 - 16:00 7.4h3brm COOKHP",
    "type": "cook"
  },
  {
    "name": "Lurleen N Frazier",
    "secSunday": "11:30 - 19:30 7.4h3brm STAATT",
    "secMonday": "N",
    "secTuesday": "12:00 - 20:00 7.4h3brm STAATT",
    "secWednesday": "N",
    "secThursday": "12:00 - 20:00 7.4h3brm STAATT",
    "secFriday": "11:00 - 19:00 7.4hneep STAATT",
    "secSaturday": "11:30 - 19:30 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Raul Ramirez",
    "secSunday": "10:00 - 18:00 7.4hbtr1 STAATT",
    "secMonday": "09:30 - 17:30 7.4hneep STAATT",
    "secTuesday": "09:30 - 17:30 7.4hneep STAATT",
    "secWednesday": "09:30 - 17:30 7.4hbtr2 STAATT",
    "secThursday": "A - PDO",
    "secFriday": "N",
    "secSaturday": "08:30 - 16:30 7.4hbtr1 STAATT",
    "type": "standAtt"
  },
  {
    "name": "Kassandra Sanchez",
    "secSunday": "ARDO",
    "secMonday": "ARDO",
    "secTuesday": "11:00 - 19:00 7.4hneep STAATT",
    "secWednesday": "12:00 - 20:00 7.4h3brm LDFOH",
    "secThursday": "12:00 - 20:00 7.4hbtr2 STAATT",
    "secFriday": "12:00 - 20:00 7.4h3brm STAATT",
    "secSaturday": "14:00 - 22:00 7.4h3brm LDFOH",
    "type": "standAtt"
  },
  {
    "name": "Alicia A Cohen",
    "secSunday": "A - PDO",
    "secMonday": "P: 06:00-19:00",
    "secTuesday": "P: 06:00-19:00",
    "secWednesday": "P: 06:00-19:00",
    "secThursday": "P: 06:00-19:00",
    "secFriday": "A - PDO",
    "secSaturday": "N"
  },
  {
    "name": "Megan N Hillyer",
    "secSunday": "11:30 - 19:30 7.4h3brm STAATT",
    "secMonday": "A",
    "secTuesday": "A",
    "secWednesday": "10:30 - 18:30 7.4h3brm STAATT",
    "secThursday": "11:30 - 19:30 7.4hbtr1 STAATT",
    "secFriday": "12:00 - 20:00 7.4hbtr2 STAATT",
    "secSaturday": "12:00 - 20:00 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Kimberly A Lopez",
    "secSunday": "08:30 - 16:30 7.4hbtr2 STAATT",
    "secMonday": "09:00 - 17:00 7.4h3brm STAATT",
    "secTuesday": "P: 06:00-17:00",
    "secWednesday": "10:00 - 16:00 6h3brm STAATT",
    "secThursday": "P: 06:00-17:00",
    "secFriday": "08:30 - 16:30 7.4hneep STAATT",
    "secSaturday": "09:00 - 17:00 7.4hbtr1 STAATT",
    "type": "standAtt"
  },
  {
    "name": "Sharon Ortega",
    "secSunday": "08:30 - 16:30 7.4hneep STAATT",
    "secMonday": "10:30 - 18:00 6.9hbtr2 STAATT",
    "secTuesday": "09:30 - 17:30 7.4h3brm STAATT",
    "secWednesday": "09:30 - 17:30 7.4hneep STAATT",
    "secThursday": "10:00 - 18:00 7.4h3brm STAATT",
    "secFriday": "N",
    "secSaturday": "N",
    "type": "standAtt"
  },
  {
    "name": "Mark A Trevizo",
    "secSunday": "10:30 - 18:30 7.4h3brm COOKHP",
    "secMonday": "10:00 - 18:00 7.4h3brm COOKHP",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "10:00 - 18:00 7.4h3brm COOKHP",
    "secFriday": "P: 10:00-23:30VAC",
    "secSaturday": "P: 10:00-23:30VAC",
    "type": "cook"
  },
  {
    "name": "Guadalupe I Cornejo",
    "secSunday": "11:30 - 19:30 7.4h3brm STAATT",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "11:00 - 19:00 7.4h3brm STAATT",
    "secThursday": "12:00 - 20:00 7.4hbtr1 STAATT",
    "secFriday": "11:30 - 19:30 7.4hbtr1 STAATT",
    "secSaturday": "12:00 - 20:00 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "John R Aguila",
    "secSunday": "08:00 - 16:00 7.4h3brm COOKHP",
    "secMonday": "11:00 - 19:00 7.4h3brm COOKHP",
    "secTuesday": "11:00 - 19:00 7.4h3brm COOKHP",
    "secWednesday": "A",
    "secThursday": "16:00 - 00:00 7.4hfood COOK  FDWN",
    "secFriday": "16:00 - 00:00 7.4hfood COOK  FDWN",
    "secSaturday": "A",
    "type": "cook"
  },
  {
    "name": "Christopher D Wilson",
    "secSunday": "08:00 - 16:00 7.4h3brm COOKHP",
    "secMonday": "P: 07:00-19:00",
    "secTuesday": "P: 07:00-19:00",
    "secWednesday": "10:00 - 18:00 7.4h3brm COOKHP",
    "secThursday": "12:00 - 20:00 7.4hfood COOK  FDWN",
    "secFriday": "12:00 - 20:00 7.4hfood COOK  FDWN",
    "secSaturday": "08:00 - 16:00 7.4h3brm COOKHP",
    "type": "cook"
  },
  {
    "name": "Vanessa D Rodriguez",
    "secSunday": "P: 04:00-20:00RDO",
    "secMonday": "P: 04:00-20:00RDO",
    "secTuesday": "07:00 - 15:00 7.4h3brm PREP",
    "secWednesday": "10:00 - 18:00 7.4h3brm COOKHP",
    "secThursday": "11:00 - 19:00 7.4h3brm COOKHP",
    "secFriday": "07:00 - 15:00 7.4h3brm PREP",
    "secSaturday": "10:30 - 18:30 7.4h3brm COOKHP",
    "type": "cook"
  },
  {
    "name": "Natalya A Galarza",
    "secSunday": "P: 06:00-16:00",
    "secMonday": "07:00 - 15:30 8hprod ADMN11  MP01",
    "secTuesday": "07:00 - 15:30 8hprod ADMN11  MP01",
    "secWednesday": "07:00 - 15:30 8hprod ADMN11  MP01",
    "secThursday": "07:00 - 15:30 8hprod ADMN11  MP01",
    "secFriday": "07:00 - 15:30 8hprod ADMN11  MP01",
    "secSaturday": "P: 06:00-16:00"
  },
  {
    "name": "Shaun Loeser",
    "secSunday": "A - PDO",
    "secMonday": "A - PDO",
    "secTuesday": "11:30 - 19:30 7.4h3brm COOKHP",
    "secWednesday": "09:30 - 18:12 8hfood TRNRCL  JTFD",
    "secThursday": "07:30 - 15:30 7.4hfood FDTRNR  JTFD",
    "secFriday": "09:30 - 18:12 8hfood TRNRCL  JTFD",
    "secSaturday": "07:00 - 15:00 7.4h3brm LDPREP",
    "type": "cook"
  },
  {
    "name": "Samer G Nassar",
    "secSunday": "11:30 - 19:30 7.4h3brm STAATT",
    "secMonday": "11:30 - 19:30 7.4h3brm STAATT",
    "secTuesday": "A",
    "secWednesday": "11:30 - 19:30 7.4h3brm STAATT",
    "secThursday": "09:00 - 17:00 7.4h3brm LDFOH",
    "secFriday": "12:00 - 20:00 7.4hbtr1 STAATT",
    "secSaturday": "ARDO",
    "type": "standAtt"
  },
  {
    "name": "Louis T Cooley",
    "secSunday": "09:00 - 17:00 7.4h3brm COOKHP",
    "secMonday": "A",
    "secTuesday": "A",
    "secWednesday": "11:00 - 19:00 7.4h3brm COOKHP",
    "secThursday": "11:30 - 19:30 7.4h3brm COOKHP",
    "secFriday": "10:00 - 18:00 7.4h3brm COOKHP",
    "secSaturday": "07:00 - 15:00 7.4h3brm PREP",
    "type": "cook"
  },
  {
    "name": "Robert Dunne",
    "secSunday": "10:30 - 18:30 7.4h3brm COOKHP",
    "secMonday": "A",
    "secTuesday": "A",
    "secWednesday": "11:30 - 19:30 7.4h3brm COOKHP",
    "secThursday": "11:30 - 19:30 7.4h3brm COOKHP",
    "secFriday": "10:30 - 18:30 7.4h3brm COOKHP",
    "secSaturday": "07:00 - 15:00 7.4h3brm PREP",
    "type": "cook"
  },
  {
    "name": "Kirsten Labrador",
    "secSunday": "11:00 - 19:00 7.4h3brm COOKHP",
    "secMonday": "07:00 - 15:00 7.4h3brm PREP",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "07:00 - 15:00 7.4h3brm PREP",
    "secFriday": "10:30 - 18:30 7.4h3brm COOKHP",
    "secSaturday": "07:00 - 15:00 7.4h3brm PREP",
    "type": "cook"
  },
  {
    "name": "Kevon J Taite",
    "secSunday": "11:30 - 19:30 7.4h3brm COOKHP",
    "secMonday": "11:30 - 19:30 7.4h3brm COOKHP",
    "secTuesday": "08:00 - 16:00 7.4h3brm COOKHP",
    "secWednesday": "A",
    "secThursday": "A",
    "secFriday": "10:30 - 18:30 7.4h3brm COOKHP",
    "secSaturday": "07:00 - 15:00 7.4h3brm PREP",
    "type": "cook"
  },
  {
    "name": "Regan C Danner",
    "secSunday": "A - PDO",
    "secMonday": "12:00 - 20:00 7.4h3brm LDFOH",
    "secTuesday": "11:30 - 19:30 7.4hbtr1 STAATT",
    "secWednesday": "12:00 - 20:00 7.4h3brm STAATT",
    "secThursday": "11:30 - 19:30 7.4hbtr2 STAATT",
    "secFriday": "11:30 - 19:30 7.4hbtr2 STAATT",
    "secSaturday": "A",
    "type": "leadFOH"
  },
  {
    "name": "David Munoz",
    "secSunday": "13:00 - 21:00 7.4h3brm LDBOH",
    "secMonday": "11:30 - 19:30 7.4h3brm COOKHP",
    "secTuesday": "07:00 - 15:00 7.4h3brm PREP",
    "secWednesday": "11:30 - 19:30 7.4h3brm COOKHP",
    "secThursday": "A - PDO",
    "secFriday": "12:00 - 20:00 7.4hfood COOK  FDWN",
    "secSaturday": "A",
    "type": "leadBOH"
  },
  {
    "name": "Garry S Walton Jr",
    "secSunday": "12:30 - 20:30 7.4h3brm COOKHP",
    "secMonday": "07:00 - 15:00 7.4h3brm PREP",
    "secTuesday": "A",
    "secWednesday": "A",
    "secThursday": "07:00 - 15:00 7.4h3brm PREP",
    "secFriday": "11:00 - 19:00 7.4h3brm COOKHP",
    "secSaturday": "11:00 - 19:00 7.4h3brm COOKHP",
    "type": "cook"
  },
  {
    "name": "Agustin Macias",
    "secSunday": "A",
    "secMonday": "07:30 - 15:30 7.4hfood FDTRNR  JTFD",
    "secTuesday": "09:30 - 17:30 7.4hfood FDTRNR  JTFD",
    "secWednesday": "11:30 - 19:30 7.4hfood FDTRNR  JTFD",
    "secThursday": "A - PDO",
    "secFriday": "11:30 - 19:30 7.4h3brm COOKHP",
    "secSaturday": "11:30 - 19:30 7.4h3brm COOKHP",
    "type": "cook"
  },
  {
    "name": "Morgan B Beattie",
    "secSunday": "P: 10:00-23:30VAC",
    "secMonday": "P: 10:00-23:30RDO",
    "secTuesday": "NRDO",
    "secWednesday": "N",
    "secThursday": "11:30 - 19:30 7.4h3brm COOKHP",
    "secFriday": "11:30 - 19:30 7.4h3brm COOKHP",
    "secSaturday": "13:00 - 21:00 7.4h3brm COOKHP",
    "type": "cook"
  },
  {
    "name": "Eduardo Hernandez",
    "secSunday": "13:00 - 21:00 7.4h3brm COOKHP",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "N",
    "secFriday": "11:30 - 19:30 7.4h3brm COOKHP",
    "secSaturday": "14:00 - 22:00 7.4h3brm COOKHP",
    "type": "cook"
  },
  {
    "name": "Andrew Thareererg",
    "secSunday": "13:00 - 21:00 7.4h3brm COOKHP",
    "secMonday": "11:30 - 19:30 7.4h3brm COOKHP",
    "secTuesday": "A",
    "secWednesday": "A",
    "secThursday": "14:00 - 22:00 7.4hfood COOKHP  FDWN",
    "secFriday": "12:00 - 20:00 7.4hfood COOKHP  FDWN",
    "secSaturday": "14:00 - 22:00 7.4h3brm COOKHP",
    "type": "cook"
  },
  {
    "name": "Erik A Pinto",
    "secSunday": "A",
    "secMonday": "07:30 - 15:30 7.4hfood FDTRNR  JTFD",
    "secTuesday": "09:30 - 17:30 7.4hfood FDTRNR  JTFD",
    "secWednesday": "11:30 - 19:30 7.4hfood FDTRNR  JTFD",
    "secThursday": "07:30 - 15:30 7.4hfood FDTRNR  JTFD",
    "secFriday": "09:30 - 17:30 7.4hfood FDTRNR  JTFD",
    "secSaturday": "A"
  },
  {
    "name": "Kathryn E Anderson",
    "secSunday": "N",
    "secMonday": "N",
    "secTuesday": "10:30 - 18:00 6.9hbtr2 STAATT",
    "secWednesday": "10:00 - 18:00 7.4h3brm STAATT",
    "secThursday": "09:30 - 17:30 7.4h3brm STAATT",
    "secFriday": "09:30 - 17:30 7.4h3brm STAATT",
    "secSaturday": "08:30 - 16:30 7.4hbtr2 STAATT",
    "type": "standAtt"
  },
  {
    "name": "Alexandra M Varley",
    "secSunday": "ARDO",
    "secMonday": "12:00 - 20:00 7.4h3brm STAATT",
    "secTuesday": "A",
    "secWednesday": "11:30 - 19:30 7.4hbtr1 STAATT",
    "secThursday": "10:30 - 16:30 6h3brm STAATT",
    "secFriday": "09:30 - 17:30 7.4h3brm STAATT",
    "secSaturday": "12:30 - 20:30 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Eric D Jewell",
    "secSunday": "10:00 - 18:00 7.4hbtr2 LDDISP",
    "secMonday": "11:30 - 19:30 7.4hbtr1 STAATT",
    "secTuesday": "A",
    "secWednesday": "12:00 - 20:00 7.4hbtr1 STAATT",
    "secThursday": "A",
    "secFriday": "12:00 - 20:00 7.4hbtr2 LDDISP",
    "secSaturday": "13:30 - 21:30 7.4h3brm STAATT",
    "type": "leadFOH"
  },
  {
    "name": "Janet G Cuevas",
    "secSunday": "P: 04:00-15:00",
    "secMonday": "P: 04:00-16:00VAC",
    "secTuesday": "P: 04:00-16:00VAC",
    "secWednesday": "P: 04:00-16:00VAC",
    "secThursday": "N",
    "secFriday": "07:00 - 15:00 7.4h3brm PREP",
    "secSaturday": "P: 04:00-15:00VAC",
    "type": "cook"
  },
  {
    "name": "Debbie G Otzoy",
    "secSunday": "P: 08:00-17:00VAC",
    "secMonday": "P: 08:00-17:00VAC",
    "secTuesday": "P: 08:00-17:00VAC",
    "secWednesday": "09:00 - 17:00 7.4h3brm COOKHP",
    "secThursday": "09:00 - 17:00 7.4h3brm COOKHP",
    "secFriday": "N",
    "secSaturday": "N",
    "type": "cook"
  },
  {
    "name": "Teri Chase",
    "secSunday": "08:30 - 16:30 7.4hbtr1 STAATT",
    "secMonday": "11:00 - 17:00 6hbtr1 STAATT",
    "secTuesday": "10:30 - 16:30 6hbtr1 STAATT",
    "secWednesday": "10:00 - 16:00 6hbtr1 STAATT",
    "secThursday": "11:00 - 17:00 6h3brm STAATT",
    "secFriday": "N",
    "secSaturday": "N",
    "type": "standAtt"
  },
  {
    "name": "Jessica Morga",
    "secSunday": "11:30 - 19:30 7.4h3brm STAATT",
    "secMonday": "N",
    "secTuesday": "11:30 - 17:30 6h3brm STAATT",
    "secWednesday": "N",
    "secThursday": "12:30 - 18:30 6hbtr1 STAATT",
    "secFriday": "N",
    "secSaturday": "13:30 - 21:30 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Kyle Rietta",
    "secSunday": "12:30 - 20:30 7.4h3brm STAATT",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "N",
    "secFriday": "N",
    "secSaturday": "13:30 - 21:30 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Gina M Cruz-Rolon",
    "secSunday": "A",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "A",
    "secThursday": "N",
    "secFriday": "N",
    "secSaturday": "A"
  },
  {
    "name": "Giselle Aleman",
    "secSunday": "N",
    "secMonday": "N",
    "secTuesday": "10:00 - 16:00 6hbtr2 STAATT",
    "secWednesday": "N",
    "secThursday": "11:30 - 17:30 6h3brm STAATT",
    "secFriday": "09:30 - 17:30 7.4hvend STAATT",
    "secSaturday": "P: 05:00-15:30RDO",
    "type": "standAtt"
  },
  {
    "name": "Irving Becerra",
    "secSunday": "09:00 - 15:00 6hvend STAATT",
    "secMonday": "11:00 - 19:00 7.4hneep STAATT",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "12:30 - 18:30 6hvend STAATT",
    "secFriday": "11:00 - 18:30 6.9h3brm STAATT",
    "secSaturday": "10:30 - 18:30 7.4hbtr1 STAATT",
    "type": "standAtt"
  },
  {
    "name": "Georgina M Garcia",
    "secSunday": "09:30 - 15:30 6h3brm STAATT",
    "secMonday": "N",
    "secTuesday": "P: 05:00-18:00",
    "secWednesday": "10:30 - 18:00 6.9hbtr2 STAATT",
    "secThursday": "17:30 - 23:30 6hhpfd STAATT  FDWN",
    "secFriday": "17:30 - 23:30 6hhpfd STAATT  FDWN",
    "secSaturday": "N",
    "type": "standAtt"
  },
  {
    "name": "Frank J Ojeda",
    "secSunday": "N",
    "secMonday": "N",
    "secTuesday": "P: 09:00-19:30",
    "secWednesday": "11:30 - 17:30 6h3brm STAATT",
    "secThursday": "12:30 - 18:30 6h3brm STAATT",
    "secFriday": "11:00 - 18:30 6.9h3brm STAATT",
    "secSaturday": "11:00 - 19:00 7.4hbtr2 STAATT",
    "type": "standAtt"
  },
  {
    "name": "Matthew A Serna",
    "secSunday": "08:00 - 14:00 6h3brm STAATT",
    "secMonday": "11:00 - 17:00 6h3brm STAATT",
    "secTuesday": "P: 06:00-17:00",
    "secWednesday": "10:30 - 16:30 6hbtr1 STAATT",
    "secThursday": "10:00 - 16:00 6hbtr2 STAATT",
    "secFriday": "N",
    "secSaturday": "N",
    "type": "standAtt"
  },
  {
    "name": "Saul M Aldana",
    "secSunday": "08:30 - 14:30 6h3brm STAATT",
    "secMonday": "10:00 - 16:00 6hbtr2 STAATT",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "N",
    "secFriday": "N",
    "secSaturday": "08:00 - 16:00 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Michael R Harris",
    "secSunday": "10:30 - 18:30 7.4hbtr2 STAATT",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "N",
    "secFriday": "N",
    "secSaturday": "13:30 - 21:30 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Matthew Illingworth",
    "secSunday": "N",
    "secMonday": "11:00 - 17:00 6h3brm STAATT",
    "secTuesday": "P: 06:00-17:00",
    "secWednesday": "10:00 - 16:00 6hbtr2 STAATT",
    "secThursday": "10:30 - 16:30 6hbtr2 STAATT",
    "secFriday": "08:30 - 16:00 6.9h3brm STAATT",
    "secSaturday": "N",
    "type": "standAtt"
  },
  {
    "name": "Beatriz Ventura",
    "secSunday": "08:30 - 14:30 6h3brm STAATT",
    "secMonday": "10:30 - 16:30 6hbtr1 STAATT",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "N",
    "secFriday": "N",
    "secSaturday": "N",
    "type": "standAtt"
  },
  {
    "name": "Eduardo Ceccaldi",
    "secSunday": "P: 14:00-23:00",
    "secMonday": "P: 14:00-23:00",
    "secTuesday": "11:30 - 19:30 7.4h3brm COOKHP",
    "secWednesday": "11:30 - 19:30 7.4h3brm COOKHP",
    "secThursday": "P: 14:00-23:00",
    "secFriday": "P: 14:00-23:00",
    "secSaturday": "14:00 - 22:00 7.4h3brm COOKHP",
    "type": "cook"
  },
  {
    "name": "Verenice Hernandez",
    "secSunday": "N",
    "secMonday": "P: 06:00-20:00",
    "secTuesday": "10:30 - 18:30 7.4hhpfd COOKHP  TCQF",
    "secWednesday": "07:00 - 15:00 7.4h3brm PREP",
    "secThursday": "10:30 - 18:30 7.4h3brm COOKHP",
    "secFriday": "07:00 - 15:00 7.4h3brm PREP",
    "secSaturday": "N",
    "type": "cook"
  },
  {
    "name": "Melissa M Lopez",
    "secSunday": "N",
    "secMonday": "P: 07:00-17:00",
    "secTuesday": "P: 07:00-17:00",
    "secWednesday": "P: 07:00-17:00",
    "secThursday": "N",
    "secFriday": "N",
    "secSaturday": "N"
  },
  {
    "name": "Lianna Padilla",
    "secSunday": "P: 19:00-05:00",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "P: 05:00-15:00",
    "secThursday": "10:00 - 16:00 6hvend STAATT",
    "secFriday": "N",
    "secSaturday": "N",
    "type": "standAtt"
  },
  {
    "name": "Briseyda Salgado",
    "secSunday": "08:30 - 14:30 6h3brm STAATT",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "N",
    "secFriday": "N",
    "secSaturday": "10:00 - 18:00 7.4hvend STAATT",
    "type": "standAtt"
  },
  {
    "name": "Francisco J Pelayo-Bibian",
    "secSunday": "N",
    "secMonday": "N",
    "secTuesday": "P: 05:00-18:00",
    "secWednesday": "P: 05:00-18:00",
    "secThursday": "P: 05:00-18:00",
    "secFriday": "P: 05:00-17:00",
    "secSaturday": "P: 05:00-15:00"
  },
  {
    "name": "Liseth Reynoso",
    "secSunday": "N",
    "secMonday": "P: 08:30-18:00",
    "secTuesday": "N",
    "secWednesday": "P: 08:30-18:00",
    "secThursday": "N",
    "secFriday": "08:30 - 16:00 6.9h3brm STAATT",
    "secSaturday": "08:30 - 16:30 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Raymond Gonzalez",
    "secSunday": "N",
    "secMonday": "P: 06:00-04:00",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "N",
    "secFriday": "N",
    "secSaturday": "N"
  },
  {
    "name": "Janet Pereda",
    "secSunday": "A",
    "secMonday": "P: 05:00-15:30",
    "secTuesday": "12:00 - 20:00 7.4hbtr2 LDDISP",
    "secWednesday": "A - PDORDO",
    "secThursday": "A - PDORDO",
    "secFriday": "08:30 - 16:00 6.9h3brm STAATT",
    "secSaturday": "14:00 - 22:00 7.4hbtr2 LDDISP",
    "type": "leadFOH"
  },
  {
    "name": "Connie R Acosta",
    "secSunday": "A",
    "secMonday": "A",
    "secTuesday": "A",
    "secWednesday": "A",
    "secThursday": "A",
    "secFriday": "N",
    "secSaturday": "N"
  },
  {
    "name": "Natalia A Lozano",
    "secSunday": "N",
    "secMonday": "N",
    "secTuesday": "P: 05:00-17:00",
    "secWednesday": "P: 05:00-17:00",
    "secThursday": "10:00 - 16:00 6hvend STAATT",
    "secFriday": "08:30 - 14:30 6h3brm STAATT",
    "secSaturday": "08:30 - 16:30 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Marissa Rodriguez",
    "secSunday": "08:30 - 14:30 6h3brm STAATT",
    "secMonday": "P: 06:00-16:00",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "N",
    "secFriday": "N",
    "secSaturday": "08:00 - 14:00 6h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Jonathan A Hernandez",
    "secSunday": "09:00 - 15:00 6h3brm STAATT",
    "secMonday": "P: 06:00-16:00",
    "secTuesday": "P: 06:00-17:00",
    "secWednesday": "N",
    "secThursday": "11:00 - 17:00 6h3brm STAATT",
    "secFriday": "N",
    "secSaturday": "N",
    "type": "standAtt"
  },
  {
    "name": "Tatiana J Hill",
    "secSunday": "09:00 - 15:00 6h3brm STAATT",
    "secMonday": "P: 05:00-18:00",
    "secTuesday": "N",
    "secWednesday": "P: 05:00-18:00",
    "secThursday": "P: 05:00-18:00RDO",
    "secFriday": "N",
    "secSaturday": "N",
    "type": "standAtt"
  },
  {
    "name": "Ashley P Munoz",
    "secSunday": "12:30 - 20:30 7.4h3brm STAATT",
    "secMonday": "12:00 - 20:00 7.4hbtr1 STAATT",
    "secTuesday": "N",
    "secWednesday": "A",
    "secThursday": "N",
    "secFriday": "ARDO",
    "secSaturday": "13:30 - 21:30 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Samantha R Quimpo",
    "secSunday": "N",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "N",
    "secFriday": "08:30 - 14:30 6h3brm STAATT",
    "secSaturday": "14:00 - 22:00 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Emely P Ramos",
    "secSunday": "12:30 - 20:30 7.4hbtr2 STAATT",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "N",
    "secFriday": "N",
    "secSaturday": "13:30 - 21:30 7.4hbtr1 STAATT",
    "type": "standAtt"
  },
  {
    "name": "Philiciti Rito",
    "secSunday": "10:30 - 16:30 6h3brm STAATT",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "N",
    "secFriday": "N",
    "secSaturday": "08:30 - 16:30 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Helen Ceron",
    "secSunday": "N",
    "secMonday": "ARDO",
    "secTuesday": "P: 05:00-16:00RDO",
    "secWednesday": "P: 05:00-16:00RDO",
    "secThursday": "P: 05:00-16:00RDO",
    "secFriday": "ARDO",
    "secSaturday": "N"
  },
  {
    "name": "Desiree Rangel",
    "secSunday": "08:30 - 14:30 6hbtr1 STAATT",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "11:30 - 17:30 6h3brm STAATT",
    "secFriday": "11:00 - 17:00 6h3brm STAATT",
    "secSaturday": "14:00 - 22:00 7.4hbtr1 STAATT",
    "type": "standAtt"
  },
  {
    "name": "Sean M Dirat",
    "secSunday": "N",
    "secMonday": "P: 06:00-17:00",
    "secTuesday": "P: 06:00-17:00",
    "secWednesday": "P: 06:00-17:00",
    "secThursday": "N",
    "secFriday": "12:30 - 18:30 6hvend STAATT",
    "secSaturday": "N",
    "type": "standAtt"
  },
  {
    "name": "Lesley F Quito",
    "secSunday": "N",
    "secMonday": "P: 06:00-18:00",
    "secTuesday": "P: 06:00-18:00",
    "secWednesday": "P: 06:00-18:00",
    "secThursday": "17:30 - 23:30 6hhpfd STAATT  FDWN",
    "secFriday": "17:30 - 23:30 6hhpfd STAATT  FDWN",
    "secSaturday": "10:30 - 18:00 6.9hneep STAATT",
    "type": "standAtt"
  },
  {
    "name": "Marilyn Lopez",
    "secSunday": "13:00 - 21:00 7.4h3brm COOKHP",
    "secMonday": "ARDO",
    "secTuesday": "ARDO",
    "secWednesday": "07:00 - 15:00 7.4h3brm PREP",
    "secThursday": "07:00 - 15:00 7.4h3brm PREP",
    "secFriday": "07:00 - 15:00 7.4h3brm PREP",
    "secSaturday": "N",
    "type": "cook"
  },
  {
    "name": "Shelly X Cabrera",
    "secSunday": "12:30 - 20:30 7.4h3brm STAATT",
    "secMonday": "11:30 - 19:30 7.4hbtr2 STAATT",
    "secTuesday": "A - PDO",
    "secWednesday": "A - PDO",
    "secThursday": "12:30 - 18:30 6h3brm STAATT",
    "secFriday": "10:30 - 16:30 6hvend STAATT",
    "secSaturday": "11:30 - 19:30 7.4hneep STAATT",
    "type": "standAtt"
  },
  {
    "name": "Jonathan M Cedeno",
    "secSunday": "12:30 - 20:30 7.4h3brm STAATT",
    "secMonday": "12:30 - 18:30 6h3brm STAATT",
    "secTuesday": "A",
    "secWednesday": "A - PDO",
    "secThursday": "10:30 - 16:30 6h3brm STAATT",
    "secFriday": "12:30 - 18:30 6hbtr1 STAATT",
    "secSaturday": "13:00 - 21:00 7.4hbtr2 STAATT",
    "type": "standAtt"
  },
  {
    "name": "Elizabeth M Landero",
    "secSunday": "N",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "P: 11:00-00:00",
    "secFriday": "10:00 - 16:00 6hbtr2 STAATT",
    "secSaturday": "13:30 - 21:30 7.4hbtr2 STAATT",
    "type": "standAtt"
  },
  {
    "name": "Christopher J Lechuga",
    "secSunday": "08:00 - 16:00 7.4h3brm LDFOH",
    "secMonday": "12:30 - 18:30 6h3brm STAATT",
    "secTuesday": "A",
    "secWednesday": "A",
    "secThursday": "A",
    "secFriday": "09:00 - 15:00 6hbtr2 STAATT",
    "secSaturday": "11:00 - 19:00 7.4h3brm STAATT",
    "type": "leadFOH"
  },
  {
    "name": "Deisy A Ponce",
    "secSunday": "ARDO",
    "secMonday": "ARDO",
    "secTuesday": "A",
    "secWednesday": "A",
    "secThursday": "17:30 - 23:30 6hhpfd STAATT  FDWN",
    "secFriday": "17:30 - 23:30 6hhpfd STAATT  FDWN",
    "secSaturday": "11:00 - 18:30 6.9h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Christopher Mcelroy",
    "secSunday": "P: 15:00-03:00",
    "secMonday": "P: 15:00-03:00",
    "secTuesday": "P: 15:00-03:00",
    "secWednesday": "P: 15:00-03:00",
    "secThursday": "P: 15:00-03:00",
    "secFriday": "16:00 - 00:00 7.4hfood COOKHP  FDWN",
    "secSaturday": "P: 15:00-03:00",
    "type": "cook"
  },
  {
    "name": "Nicole Toubia",
    "secSunday": "07:00 - 15:00 7.4h3brm PREP",
    "secMonday": "A",
    "secTuesday": "10:30 - 18:30 7.4hhpfd COOKHP  TCQF",
    "secWednesday": "07:00 - 15:00 7.4h3brm PREP",
    "secThursday": "N",
    "secFriday": "N",
    "secSaturday": "07:00 - 15:00 7.4h3brm PREP",
    "type": "cook"
  },
  {
    "name": "Andrew Avila",
    "secSunday": "13:00 - 21:00 7.4h3brm STAATT",
    "secMonday": "12:30 - 18:30 6h3brm STAATT",
    "secTuesday": "A",
    "secWednesday": "A - PDO",
    "secThursday": "A",
    "secFriday": "08:30 - 14:30 6h3brm STAATT",
    "secSaturday": "12:00 - 19:30 6.9h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Desirae Valdez A Valdez",
    "secSunday": "09:00 - 15:00 6hbtr1 STAATT",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "N",
    "secFriday": "08:30 - 14:30 6hbtr1 STAATT",
    "secSaturday": "12:00 - 19:30 6.9hbtr1 STAATT",
    "type": "standAtt"
  },
  {
    "name": "Michelle Gonzalez Nambo",
    "secSunday": "09:00 - 15:00 6hbtr2 STAATT",
    "secMonday": "N",
    "secTuesday": "A",
    "secWednesday": "N",
    "secThursday": "A",
    "secFriday": "17:30 - 23:30 6hhpfd STAATT  FDWN",
    "secSaturday": "11:00 - 18:30 6.9h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Celine C Merino",
    "secSunday": "12:30 - 20:30 7.4hbtr1 STAATT",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "N",
    "secFriday": "N",
    "secSaturday": "11:30 - 18:30 6.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Katherine A Resnik",
    "secSunday": "13:00 - 21:00 7.4hbtr1 STAATT",
    "secMonday": "A",
    "secTuesday": "A",
    "secWednesday": "A",
    "secThursday": "A",
    "secFriday": "17:30 - 23:30 6hhpfd STAATT  FDWN",
    "secSaturday": "10:00 - 16:00 6h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Jonathan Saavedra",
    "secSunday": "07:00 - 15:00 7.4h3brm PREP",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "N",
    "secFriday": "N",
    "secSaturday": "14:00 - 22:00 7.4h3brm COOKHP",
    "type": "cook"
  },
  {
    "name": "Marissa Tovar",
    "secSunday": "11:00 - 18:30 6.9h3brm STAATT",
    "secMonday": "P: 06:30-14:30",
    "secTuesday": "P: 06:30-14:30",
    "secWednesday": "P: 06:30-14:30",
    "secThursday": "P: 06:30-13:30",
    "secFriday": "10:00 - 16:00 6h3brm STAATT",
    "secSaturday": "10:00 - 16:00 6h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Dedrick R Hayes",
    "secSunday": "N",
    "secMonday": "A",
    "secTuesday": "A",
    "secWednesday": "11:00 - 19:00 7.4hhpfd COOKHP  TCQF",
    "secThursday": "11:00 - 19:00 7.4h3brm COOKHP",
    "secFriday": "07:00 - 15:00 7.4h3brm PREP",
    "secSaturday": "N",
    "type": "cook"
  },
  {
    "name": "Kimberly E Cortez",
    "secSunday": "N",
    "secMonday": "A",
    "secTuesday": "A",
    "secWednesday": "A",
    "secThursday": "A",
    "secFriday": "12:30 - 18:30 6h3brm STAATT",
    "secSaturday": "10:00 - 16:00 6h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Julia M Lopez",
    "secSunday": "11:00 - 18:30 6.9h3brm STAATT",
    "secMonday": "A",
    "secTuesday": "A",
    "secWednesday": "A",
    "secThursday": "A",
    "secFriday": "11:30 - 17:30 6h3brm STAATT",
    "secSaturday": "10:00 - 16:00 6h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Michael A Mazadiego",
    "secSunday": "07:00 - 15:00 7.4h3brm PREP",
    "secMonday": "A",
    "secTuesday": "A",
    "secWednesday": "11:00 - 19:00 7.4hhpfd COOKHP  TCQF",
    "secThursday": "11:00 - 19:00 7.4hhpfd COOKHP  TCQF",
    "secFriday": "07:30 - 15:30 7.4h3brm COOKHP",
    "secSaturday": "11:00 - 19:00 7.4h3brm COOKHP",
    "type": "cook"
  },
  {
    "name": "Julie M Moreno",
    "secSunday": "N",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "A",
    "secThursday": "A",
    "secFriday": "N",
    "secSaturday": "N"
  },
  {
    "name": "Erick G Villarreal",
    "secSunday": "ADNS",
    "secMonday": "P: 13:00-04:00",
    "secTuesday": "P: 13:00-04:00",
    "secWednesday": "P: 13:00-04:00",
    "secThursday": "P: 13:00-04:00",
    "secFriday": "A",
    "secSaturday": "10:30 - 16:30 6h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Sheyla A Alarcon",
    "secSunday": "13:30 - 19:30 6hbtr1 STAATT",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "N",
    "secFriday": "N",
    "secSaturday": "12:00 - 18:00 6h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Elder R Jerez",
    "secSunday": "11:00 - 18:30 6.9hvend STAATT",
    "secMonday": "N",
    "secTuesday": "P: 08:00-20:00",
    "secWednesday": "P: 08:00-20:00",
    "secThursday": "P: 08:00-20:00",
    "secFriday": "P: 08:00-20:00",
    "secSaturday": "12:00 - 18:00 6h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Donald C Lamont-jones",
    "secSunday": "13:30 - 19:30 6hvend STAATT",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "A",
    "secThursday": "A",
    "secFriday": "A",
    "secSaturday": "12:00 - 18:00 6h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Jerry Leyva",
    "secSunday": "09:00 - 15:00 6hbtr2 STAATT",
    "secMonday": "A",
    "secTuesday": "A",
    "secWednesday": "A",
    "secThursday": "A",
    "secFriday": "A",
    "secSaturday": "12:00 - 18:00 6h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Camila J Flores",
    "secSunday": "A",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "A",
    "secThursday": "A",
    "secFriday": "A",
    "secSaturday": "10:00 - 16:00 6hbtr1 STAATT",
    "type": "standAtt"
  },
  {
    "name": "Donald E Holland",
    "secSunday": "A",
    "secMonday": "P: 06:00-16:00",
    "secTuesday": "A",
    "secWednesday": "A",
    "secThursday": "P: 06:00-16:00",
    "secFriday": "A",
    "secSaturday": "09:00 - 15:00 6hbtr2 STAATT",
    "type": "standAtt"
  },
  {
    "name": "Emily A Martin",
    "secSunday": "A",
    "secMonday": "A",
    "secTuesday": "A",
    "secWednesday": "A",
    "secThursday": "A",
    "secFriday": "A",
    "secSaturday": "09:00 - 15:00 6hvend STAATT",
    "type": "standAtt"
  },
  {
    "name": "Cynthia T Romero",
    "secSunday": "A",
    "secMonday": "N",
    "secTuesday": "A",
    "secWednesday": "N",
    "secThursday": "A",
    "secFriday": "A",
    "secSaturday": "ADNS"
  },
  {
    "name": "Benjamin G Hayes",
    "secSunday": "P: 09:00-21:30",
    "secMonday": "N",
    "secTuesday": "A",
    "secWednesday": "P: 10:30-23:00",
    "secThursday": "A",
    "secFriday": "A",
    "secSaturday": "10:00 - 16:00 6hbtr2 STAATT",
    "type": "standAtt"
  },
  {
    "name": "Angelica M Palacio",
    "secSunday": "A",
    "secMonday": "A",
    "secTuesday": "N",
    "secWednesday": "A - PDO",
    "secThursday": "A - PDO",
    "secFriday": "A",
    "secSaturday": "08:30 - 14:30 6hneep STAATT",
    "type": "standAtt"
  },
  {
    "name": "Michelle A Zelaya",
    "secSunday": "A",
    "secMonday": "N",
    "secTuesday": "A",
    "secWednesday": "N",
    "secThursday": "A",
    "secFriday": "A",
    "secSaturday": "08:00 - 14:00 6h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Marvina M Hubbard",
    "secSunday": "N",
    "secMonday": "N",
    "secTuesday": "A",
    "secWednesday": "A",
    "secThursday": "11:00 - 19:00 7.4hhpfd COOKHP  TCQF",
    "secFriday": "09:00 - 17:00 7.4h3brm COOKHP",
    "secSaturday": "A",
    "type": "cook"
  },
  {
    "name": "Cherry Lynne F Aguilar",
    "secSunday": "07:00 - 15:00 7.4h3brm PREP",
    "secMonday": "A",
    "secTuesday": "A",
    "secWednesday": "A",
    "secThursday": "A",
    "secFriday": "07:00 - 15:00 7.4h3brm PREP",
    "secSaturday": "A",
    "type": "cook"
  },
  {
    "name": "Brenda L Cervantes",
    "secSunday": "A",
    "secMonday": "A",
    "secTuesday": "A",
    "secWednesday": "A",
    "secThursday": "A",
    "secFriday": "11:00 - 19:00 7.4hhpfd COOKHP  TCQF",
    "secSaturday": "A",
    "type": "cook"
  },
  {
    "name": "David A Nguyen",
    "secSunday": "A",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "N",
    "secFriday": "N",
    "secSaturday": "10:00 - 16:00 6h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Russel M Santiago",
    "secSunday": "A",
    "secMonday": "P: 13:00-00:00",
    "secTuesday": "A",
    "secWednesday": "P: 13:00-00:00",
    "secThursday": "N",
    "secFriday": "A",
    "secSaturday": "08:00 - 14:00 6h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Michelle M Garcia",
    "secSunday": "A",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "A",
    "secFriday": "A",
    "secSaturday": "10:00 - 16:00 6h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "William T Bastin",
    "secSunday": "A",
    "secMonday": "A",
    "secTuesday": "A",
    "secWednesday": "A",
    "secThursday": "A",
    "secFriday": "A",
    "secSaturday": "A"
  },
  {
    "name": "Jammiee Y Benbo",
    "secSunday": "A",
    "secMonday": "A",
    "secTuesday": "A",
    "secWednesday": "A",
    "secThursday": "A",
    "secFriday": "A",
    "secSaturday": "A"
  },
  {
    "name": "Tiphani Clark",
    "secSunday": "P: 16:00-04:00",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "P: 16:00-04:00",
    "secFriday": "P: 16:00-04:00",
    "secSaturday": "P: 16:00-04:00"
  },
  {
    "name": "Sean R Gonzalez",
    "secSunday": "N",
    "secMonday": "A",
    "secTuesday": "P: 15:00-01:00",
    "secWednesday": "A",
    "secThursday": "P: 15:00-01:00",
    "secFriday": "N",
    "secSaturday": "N"
  },
  {
    "name": "Joseph M Martinez",
    "secSunday": "A",
    "secMonday": "A",
    "secTuesday": "P: 14:00-00:00",
    "secWednesday": "A",
    "secThursday": "P: 14:00-00:00",
    "secFriday": "A",
    "secSaturday": "A"
  },
  {
    "name": "Andrew J Montes",
    "secSunday": "A",
    "secMonday": "A",
    "secTuesday": "A",
    "secWednesday": "A",
    "secThursday": "A",
    "secFriday": "A",
    "secSaturday": "A"
  },
  {
    "name": "Aleksandra I Murga Higueros",
    "secSunday": "A",
    "secMonday": "A",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "N",
    "secFriday": "A",
    "secSaturday": "A - PDO"
  },
  {
    "name": "Yosselin L Pineda",
    "secSunday": "N",
    "secMonday": "A",
    "secTuesday": "A",
    "secWednesday": "A",
    "secThursday": "A",
    "secFriday": "N",
    "secSaturday": "N"
  },
  {
    "name": "Axel O Rosa Rodriguez",
    "secSunday": "N",
    "secMonday": "A",
    "secTuesday": "A",
    "secWednesday": "A",
    "secThursday": "A",
    "secFriday": "N",
    "secSaturday": "N"
  },
  {
    "name": "Gerald R Ruiz",
    "secSunday": "A",
    "secMonday": "P: 08:00-17:00",
    "secTuesday": "P: 08:00-17:00",
    "secWednesday": "A",
    "secThursday": "A",
    "secFriday": "A",
    "secSaturday": "A"
  },
  {
    "name": "Kadie D Williams",
    "secSunday": "A",
    "secMonday": "A",
    "secTuesday": "A",
    "secWednesday": "12:00 - 20:00 7.4hbtr2 LDDISP",
    "secThursday": "A",
    "secFriday": "A",
    "secSaturday": "A",
    "type": "leadFOH"
  },
  {
    "name": "Jaylin R Young",
    "secSunday": "A",
    "secMonday": "A",
    "secTuesday": "A",
    "secWednesday": "A",
    "secThursday": "A",
    "secFriday": "A",
    "secSaturday": "A"
  },
  {
    "name": "Krissia L Flores",
    "secSunday": "A",
    "secMonday": "P: 15:00-01:00",
    "secTuesday": "N",
    "secWednesday": "P: 15:00-01:00",
    "secThursday": "N",
    "secFriday": "A",
    "secSaturday": "A"
  },
  {
    "name": "LeRoy M Ellis III",
    "secSunday": "A",
    "secMonday": "A",
    "secTuesday": "A",
    "secWednesday": "A",
    "secThursday": "A",
    "secFriday": "A",
    "secSaturday": "A"
  },
  {
    "name": "Julian O Sanabria Hernandez",
    "secSunday": "P: 07:30-19:30",
    "secMonday": "A",
    "secTuesday": "A - PDO",
    "secWednesday": "P: 07:30-19:30",
    "secThursday": "A",
    "secFriday": "P: 07:30-19:30",
    "secSaturday": "P: 07:30-19:30"
  },
  {
    "name": "Jon-Eric D Williams",
    "secSunday": "N",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "P: 03:00-15:00",
    "secFriday": "N",
    "secSaturday": "N"
  },
  {
    "name": "Bryan A Delgado",
    "secSunday": "N",
    "secMonday": "P: 05:00-17:00",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "N",
    "secFriday": "N",
    "secSaturday": "N"
  },
  {
    "name": "Alejandra Martinez-Rivera",
    "secSunday": "P: 03:00-13:00",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "N",
    "secFriday": "N",
    "secSaturday": "P: 21:00-07:00"
  },
  {
    "name": "Heriberto Sanchez",
    "secSunday": "P: 05:00-15:00",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "N",
    "secFriday": "N",
    "secSaturday": "P: 05:00-15:00"
  },
  {
    "name": "Irene Correa",
    "secSunday": "N",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "N",
    "secFriday": "P: 04:00-14:00",
    "secSaturday": "P: 04:00-14:00"
  },
  {
    "name": "Yvonne S Guerrero",
    "secSunday": "P: 03:00-17:00",
    "secMonday": "P: 03:00-14:00 - PDO",
    "secTuesday": "P: 03:00-16:00",
    "secWednesday": "N - PDO",
    "secThursday": "P: 03:00-16:00",
    "secFriday": "P: 03:00-16:00",
    "secSaturday": "P: 03:00-17:00"
  },
  {
    "name": "Giancarlo De Leon",
    "secSunday": "N",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "A",
    "secFriday": "12:00 - 20:00 7.4hfood COOKHP  FDWN",
    "secSaturday": "N",
    "type": "cook"
  },
  {
    "name": "Adrian J Gonzalez",
    "secSunday": "P: 04:00-13:00",
    "secMonday": "P: 04:00-13:00",
    "secTuesday": "N - PDO",
    "secWednesday": "N - PDO",
    "secThursday": "P: 04:00-13:00",
    "secFriday": "N - PDO",
    "secSaturday": "N - PDO"
  },
  {
    "name": "Jorge L Mac",
    "secSunday": "P: 05:00-13:00",
    "secMonday": "N",
    "secTuesday": "P: 05:00-13:00",
    "secWednesday": "A",
    "secThursday": "N",
    "secFriday": "N",
    "secSaturday": "N"
  },
  {
    "name": "Vanessa Fierro",
    "secSunday": "N",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "N",
    "secFriday": "P: 10:00-20:00",
    "secSaturday": "N"
  },
  {
    "name": "Allison A Norris",
    "secSunday": "P: 02:00-16:00",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "N",
    "secFriday": "N",
    "secSaturday": "P: 02:00-16:00"
  },
  {
    "name": "Anna C Lucas",
    "secSunday": "N",
    "secMonday": "P: 04:30-14:30",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "N",
    "secFriday": "P: 04:30-14:30",
    "secSaturday": "N"
  },
  {
    "name": "Christopher O Sahagun",
    "secSunday": "P: 05:00-19:00",
    "secMonday": "N",
    "secTuesday": "P: 15:00-03:00",
    "secWednesday": "P: 15:00-03:00",
    "secThursday": "P: 16:00-04:00",
    "secFriday": "P: 12:30-01:00",
    "secSaturday": "P: 05:00-20:00"
  },
  {
    "name": "Isabel D Carranza",
    "secSunday": "N",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "N",
    "secFriday": "P: 07:00-17:00",
    "secSaturday": "P: 07:00-17:00"
  },
  {
    "name": "Raul Cossio",
    "secSunday": "N",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "A",
    "secThursday": "A",
    "secFriday": "N",
    "secSaturday": "N"
  },
  {
    "name": "Mario Ortiz",
    "secSunday": "P: 03:00-13:00",
    "secMonday": "P: 07:00-17:00",
    "secTuesday": "P: 07:00-17:00",
    "secWednesday": "P: 07:00-17:00",
    "secThursday": "P: 07:00-17:00",
    "secFriday": "P: 07:00-17:00",
    "secSaturday": "P: 03:00-13:00"
  },
  {
    "name": "Patricia Huelgas",
    "secSunday": "N",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "N",
    "secFriday": "P: 06:00-16:00",
    "secSaturday": "N"
  },
  {
    "name": "Samantha R Maldonado",
    "secSunday": "P: 11:00-09:00",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "N",
    "secFriday": "N",
    "secSaturday": "P: 07:00-08:00"
  },
  {
    "name": "Lexus M Lopez",
    "secSunday": "A",
    "secMonday": "P: 18:00-06:00",
    "secTuesday": "P: 20:00-06:00",
    "secWednesday": "P: 18:00-06:00",
    "secThursday": "P: 20:00-06:00",
    "secFriday": "N",
    "secSaturday": "N"
  },
  {
    "name": "Angie N Quintanilla",
    "secSunday": "A - PDO",
    "secMonday": "N",
    "secTuesday": "A",
    "secWednesday": "N",
    "secThursday": "A",
    "secFriday": "A",
    "secSaturday": "A"
  },
  {
    "name": "Sean T Trainotti",
    "secSunday": "A",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "N",
    "secFriday": "N",
    "secSaturday": "A"
  },
  {
    "name": "Jeanette n Hardy",
    "secSunday": "A",
    "secMonday": "A",
    "secTuesday": "A",
    "secWednesday": "A",
    "secThursday": "A",
    "secFriday": "16:00 - 00:00 7.4hfood COOKHP  FDWN",
    "secSaturday": "A",
    "type": "cook"
  },
  {
    "name": "Kassandra Godinez Sandoval",
    "secSunday": "A",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "N",
    "secFriday": "A - PDO",
    "secSaturday": "A"
  },
  {
    "name": "Doniece L McGee",
    "secSunday": "A",
    "secMonday": "A",
    "secTuesday": "A",
    "secWednesday": "A",
    "secThursday": "A",
    "secFriday": "N",
    "secSaturday": "A"
  },
  {
    "name": "Antoinette M Paris",
    "secSunday": "A",
    "secMonday": "N",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "N",
    "secFriday": "N",
    "secSaturday": "A"
  },
  {
    "name": "Precious D Hernandez",
    "secSunday": "A",
    "secMonday": "A",
    "secTuesday": "A",
    "secWednesday": "A",
    "secThursday": "A",
    "secFriday": "A",
    "secSaturday": "A"
  },
  {
    "name": "Heather Barton",
    "secSunday": "11:00 - 19:00 7.4h3brm STAATT",
    "secMonday": "10:30 - 18:30 7.4h3brm STAATT",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "11:30 - 19:30 7.4h3brm STAATT",
    "secFriday": "11:30 - 19:30 7.4h3brm STAATT",
    "secSaturday": "12:00 - 20:00 7.4h3brm STAATT",
    "type": "standAtt"
  },
  {
    "name": "Bruce B Barber",
    "secSunday": "P: 05:00-16:00",
    "secMonday": "P: 05:00-16:00",
    "secTuesday": "P: 05:00-16:00",
    "secWednesday": "P: 05:00-16:00",
    "secThursday": "P: 05:00-16:00",
    "secFriday": "P: 05:00-16:00",
    "secSaturday": "P: 05:00-16:00"
  },
  {
    "name": "Juan Contreras",
    "secSunday": "",
    "secMonday": "",
    "secTuesday": "",
    "secWednesday": "",
    "secThursday": "",
    "secFriday": "",
    "secSaturday": ""
  },
  {
    "name": "Autumn M Denham",
    "secSunday": "",
    "secMonday": "",
    "secTuesday": "",
    "secWednesday": "",
    "secThursday": "",
    "secFriday": "",
    "secSaturday": ""
  },
  {
    "name": "Melanie J Garcia",
    "secSunday": "",
    "secMonday": "",
    "secTuesday": "",
    "secWednesday": "",
    "secThursday": "",
    "secFriday": "",
    "secSaturday": ""
  },
  {
    "name": "Destinee Gorrocino",
    "secSunday": "P: 04:00-16:00",
    "secMonday": "A",
    "secTuesday": "A",
    "secWednesday": "P: 04:00-16:00",
    "secThursday": "P: 04:00-16:00",
    "secFriday": "P: 04:00-16:00",
    "secSaturday": "P: 04:00-16:00"
  },
  {
    "name": "Dajonique L Howard",
    "secSunday": "A",
    "secMonday": "A",
    "secTuesday": "A",
    "secWednesday": "A",
    "secThursday": "A",
    "secFriday": "A",
    "secSaturday": "A"
  },
  {
    "name": "Andrew J Martinez",
    "secSunday": "N",
    "secMonday": "N",
    "secTuesday": "P: 06:00-17:00",
    "secWednesday": "P: 06:00-17:00",
    "secThursday": "P: 06:00-17:00",
    "secFriday": "P: 06:00-17:00",
    "secSaturday": "P: 06:00-17:00"
  },
  {
    "name": "Jose D Ortega",
    "secSunday": "A",
    "secMonday": "A",
    "secTuesday": "A",
    "secWednesday": "A",
    "secThursday": "A",
    "secFriday": "A",
    "secSaturday": "A"
  },
  {
    "name": "Arlene R Ruiz",
    "secSunday": "",
    "secMonday": "",
    "secTuesday": "",
    "secWednesday": "",
    "secThursday": "",
    "secFriday": "",
    "secSaturday": ""
  },
  {
    "name": "Derrell B Smith",
    "secSunday": "",
    "secMonday": "",
    "secTuesday": "",
    "secWednesday": "",
    "secThursday": "",
    "secFriday": "",
    "secSaturday": ""
  },
  {
    "name": "Luis M Swann",
    "secSunday": "A",
    "secMonday": "A",
    "secTuesday": "N",
    "secWednesday": "N",
    "secThursday": "A",
    "secFriday": "A",
    "secSaturday": "A"
  }
]